import { render, staticRenderFns } from "./filter-tags.vue?vue&type=template&id=c4bc1ee8&"
import script from "./filter-tags.vue?vue&type=script&lang=js&"
export * from "./filter-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports